<template>
  <div id="live-chat-tab" class="text-xs-center">
    <div style="position: relative">
      <template v-if="currentLivechatExpireTime > 0">
        <div class="px-1 info caption white--text">
          แพคเกจรวมแชทคงเหลือ
          <countdown :time="currentLivechatExpireTime * 1000">
            <template slot-scope="props">
              <template v-if="props.days">
                {{ props.days | numberFormat }}
                <span class="small">{{ $t('Days') }}</span>
              </template>
              <template v-else-if="props.hours > 0">
                {{ props.hours | numberFormat }}
                <span class="small">{{ $t('Hours') }}</span>
              </template>
              <template v-else-if="props.minutes > 0">
                {{ props.minutes | numberFormat }}
                <span class="small">{{ $t('Minutes') }}</span>
              </template>
              <template v-else>
                {{ props.seconds | numberFormat }}
                <span class="small">{{ $t('Seconds') }}</span>
              </template>
            </template>
          </countdown>
        </div>
      </template>
      <v-layout style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)">
        <v-flex>
          <v-tabs
            id="usertype"
            color="white"
            :value="$store.state.livechat.inbox"
            :slider-color="$vuetify.theme.primary"
            @change="changeType"
          >
            <v-tab :key="'admin'" ripple :href="'#admin'" style="position: relative; flex: 1">
              <div>
                {{ $t('agent') }}
                <div v-if="notify && notify.agent && notify.agent > 0" class="newnotifycount">
                  {{ notificationFormat(notify.agent) }}
                </div>
              </div>
            </v-tab>
            <v-tab :key="'bot'" ripple :href="'#bot'" style="position: relative; flex: 1">
              <div>
                {{ $t('chatbot') }}
                <div v-if="notify && notify.bot && notify.bot > 0" class="newnotifycount">
                  {{ notificationFormat(notify.bot) }}
                </div>
              </div>
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-flex shrink>
          <cooldown :delay="10" cname="refresh_chat_user" @onLoad="onRefreshChatUser">
            <template #default="{ zloading, onClick, show }">
              <v-btn v-if="show" icon :loading="zloading" @click="onClick">
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
            <template #countdown="{ show, delaytime, onCountdownEnd }">
              <template v-if="show && delaytime !== true && delaytime > 0">
                <v-btn v-if="show" icon :loading="true">
                  <v-icon>refresh</v-icon>
                  <countdown :time="delaytime * 1000" @end="onCountdownEnd"> </countdown>
                </v-btn>
              </template>
            </template>
          </cooldown>
        </v-flex>
        <v-flex shrink>
          <v-menu offset-y bottom>
            <template #activator="{ on }">
              <v-btn flat icon ripple v-on="on">
                <em class="fas fa-filter" />
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                v-for="(item, i) in filterItems"
                :key="i"
                @click="handleChangeFilter(item)"
              >
                <v-list-tile-title>{{ item.label }}</v-list-tile-title>
                <v-list-tile-action class="justify-end">
                  <template v-if="currentFilter && item.value === currentFilter.value">
                    <em class="fas fa-check" />
                  </template>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
        <v-flex shrink>
          <v-btn flat icon ripple @click="$emit('onsearch', true)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)">
        <v-flex>
          <v-tabs
            id="platformType"
            :value="$store.state.livechat.platform_type"
            :slider-color="$vuetify.theme.primary"
            @change="changePlatFormType"
          >
            <v-tab :key="'inbox'" ripple :href="'#inbox'" style="position: relative; flex: 1">
              <div>
                {{ $t('all_in_one_chat.inbox') }}
                <div
                  v-if="notifyByType && notifyByType.inbox && notifyByType.inbox > 0"
                  class="newnotifycount"
                >
                  {{ notificationFormat(notifyByType.inbox) }}
                </div>
              </div>
            </v-tab>
            <v-tab :key="'page'" ripple :href="'#page'" style="position: relative; flex: 1">
              <div>
                {{ $t('all_in_one_chat.post') }}
                <div
                  v-if="notifyByType && notifyByType.post && notifyByType.post > 0"
                  class="newnotifycount"
                >
                  {{ notificationFormat(notifyByType.post) }}
                </div>
              </div>
            </v-tab>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog v-model="showSetting" scrollable persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer /><v-btn icon small @click="showSetting = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text v-if="showSetting">
          <LineQuota></LineQuota>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Cooldown from '@/components/elements/Cooldown'
import LineQuota from './LineQuota'
import LivechatSocialChannel from './LivechatSocialChannelMixin'
export default {
  components: {
    Cooldown,
    LineQuota
  },
  mixins: [LivechatSocialChannel],
  props: ['newchatnotify'],
  data() {
    return {
      showSetting: false,
      currentFilter: null,
      filterItems: [
        {
          label: 'วันที่เก่าที่สุด',
          value: 'order_by_asc'
        },
        {
          label: 'วันที่ล่าสุด',
          value: 'order_by_desc'
        },
        {
          label: 'ยังไม่ได้อ่าน',
          value: 'unread'
        },
        {
          label: 'อ่านแล้ว',
          value: 'read'
        }
      ]
    }
  },
  computed: {
    isTicketAdmin() {
      if (
        this.selectedBot.theme == 'ticket' ||
        this.$store.state.ticketPageid.includes(this.selectedBot.pageid)
      ) {
        if (
          this.selectedBot.pageid == '102549712095297' ||
          this.selectedBot.pageid == '105387828535129'
        ) {
          return true
        }
        return (
          !this.$store.state.privilege.view_ticket ||
          this.$store.state.privilege.view_ticket == 'all'
        )
      } else return true
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      searchlist: 'getLivechatSearching',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      livechat: 'livechat'
    }),
    currentLivechatExpireTime() {
      var bot = this.botlist.find((el) => {
        return el.pageid == this.$store.state.livechat.pageid
      })
      if (bot && bot.livechat_expireat != null) {
        var now = moment()
        var date = moment(bot.livechat_expireat)
        return parseInt(now.diff(date, 'seconds'))
      } else return null
    },
    notify() {
      const data = this.newchatnotify
      return {
        agent: Number(data.agent_inbox) + Number(data.agent_post),
        bot: Number(data.bot_inbox) + Number(data.bot_post)
      }
    },
    notifyByType() {
      const data = this.newchatnotify
      return {
        inbox:
          this.$store.state.livechat.inbox === 'admin'
            ? Number(data.agent_inbox)
            : Number(data.bot_inbox),
        post:
          this.$store.state.livechat.inbox === 'admin'
            ? Number(data.agent_post)
            : Number(data.bot_post)
      }
    }
  },
  mounted() {
    this.handleForceChangeType(this.$route.query.inbox)
    this.handleForcePlatformType(this.$route.query.platform_type)
  },
  methods: {
    handleForceChangeType(type) {
      // if (['bot'].includes(type)) {
      //   this.handleChangeFilter({
      //     label: 'วันที่ล่าสุด',
      //     value: 'order_by_desc'
      //   })
      // } else {
      //   this.handleChangeFilter({
      //     label: 'วันที่เก่าที่สุด',
      //     value: 'order_by_asc'
      //   })
      // }
      this.handleChangeFilter({
        label: 'วันที่เก่าที่สุด',
        value: 'order_by_asc'
      })
    },
    changeApp(type) {
      this.$store.commit('SET_LIVECHAT_APP', type)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    changeType(type) {
      this.handleForceChangeType(type)
      this.$store.commit('SET_LIVECHAT_TYPE', type)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    changePlatFormType(type) {
      this.handleForcePlatformType(type)
      this.$store.commit('SET_LIVECHAT_PLATFORM_TYPE', type)
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    onRefreshChatUser(payload) {
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
      if (payload) payload.callback()
    },
    updateRoute: function () {
      var query = { ...this.$route.query }
      query.inbox = this.$store.state.livechat.inbox
      query.platform_type = this.$store.state.livechat.platform_type

      this.$router.push({
        name: 'allinonechat',
        path: '/allinonechat',
        query: query
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    async handleChangeFilter(item) {
      const vm = this
      if (item) {
        vm.currentFilter = item

        const filter = {
          is_quick_filter: true
        }

        if (item.value === 'order_by_asc') {
          Object.assign(filter, { order_type: 'asc' })
        } else if (item.value === 'order_by_desc') {
          Object.assign(filter, { order_type: 'desc' })
        } else if (item.value === 'unread') {
          Object.assign(filter, { adminread: 'false' })
        } else {
          Object.assign(filter, { adminread: 'true' })
        }

        vm.$store.commit('SET_LIVECHAT_FILTER', filter)
        vm.$nextTick(() => {
          vm.$store.dispatch('forceLoadLastestUsers')
        })
      }
    },
    async handleForcePlatformType(item) {
      if (item) {
        this.$nextTick(() => {
          this.$store.dispatch('forceLoadLastestUsers')
        })
      }
    },
    notificationFormat(count) {
      return Number(count) <= 999 ? this.numberFormat(count) : '999+'
    }
  }
}
</script>

<style lang="scss">
#live-chat-tab .v-tabs__slider {
  height: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatTab.vue